import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DataTable from "../components/DataTable";

const ListarCentros = ({ refresh }) => {
  const [centrosFormacion, setCentrosFormacion] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 🔴 Eliminar centro (MEMORIZADO)
  const deleteCentros = useCallback(
    async (id) => {
      try {
        const result = await Swal.fire({
          title: "¿Está seguro?",
          text: "¡No podrá revertir este proceso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
        });

        if (result.isConfirmed) {
          const { data } = await axios.delete(
            `/api/centrosdeformacion/${id}`
          );

          Swal.fire({
            icon: "success",
            title: data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } catch (error) {
        console.error("Error al eliminar el centro:", error.message);
        Swal.fire("Error", "No se pudo eliminar el centro.", "error");
      }
    },
    [] // no depende de nada externo
  );

  // 📥 Obtener datos
  const getData = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/api/centrosdeformacion/listall/");
      const centros = data?.centros || [];

      const centrosConFunciones = centros
        .map((centro) => ({
          ...centro,

          // 🏫 Nombre Centro (ellipsis)
          nombreCentro: (
            <div title={centro.nombreCentro} >
              {centro.nombreCentro}
            </div>
          ),

          // 📍 Dirección (ellipsis)
          direccionCentro: (
            <div title={centro.direccionCentro} >
              {centro.direccionCentro}
            </div>
          ),

          nombreRegional:
            centro.regionalObjectId?.nombreRegional ||
            "Regional no disponible",

          funciones: (
            <div className="d-flex gap-2 justify-content-end">
              <button
                className="btn btn-warning btn-sm d-inline-flex align-items-center justify-content-center"
                style={{ width: 34, height: 34 }}
                onClick={() =>
                  navigate(`/institucional/centro/edit/${centro._id}`)
                }
                title="Editar Centro"
                type="button"
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </button>

              <button
                className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center"
                style={{ width: 34, height: 34 }}
                onClick={async () => {
                  await deleteCentros(centro._id);
                  getData(); // refrescar luego de eliminar
                }}
                title="Eliminar Centro"
                type="button"
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          ),
        }))
        .reverse();

      setCentrosFormacion(centrosConFunciones);
    } catch (error) {
      console.error("Error al cargar centros:", error.message);
    } finally {
      setLoading(false);
    }
  }, [navigate, deleteCentros]);

  useEffect(() => {
    getData();
  }, [getData, refresh]);

  // 📊 Columnas
  const columns = useMemo(
    () => [
      { Header: "Código", accessor: "codCentro" },
      {Header: "Nombre Centro", accessor: "nombreCentro"},
      {Header: "Municipio", accessor: "municipioCentro"},
      {Header: "Dirección",accessor: "direccionCentro"},
      { Header: "Regional", accessor: "nombreRegional" },
      { accessor: "funciones" },
    ],
    []
  );


  return (
    <div>
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm overflow-hidden">
          {/* Header */}
          <div className="px-3 px-md-4 py-3 border-bottom bg-white">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
              <div>
                <h5 className="mt-2 mb-1 fw-semibold">
                  Centros de Formación
                </h5>
                <small className="text-secondary">
                  Gestión institucional y administración de centros.
                </small>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={getData}
                  disabled={loading}
                >
                  <i
                    className={`fa-solid ${loading ? "fa-spinner fa-spin" : "fa-rotate"
                      } me-2`}
                  ></i>
                  Actualizar
                </button>

                <button
                  className="btn btn-dark"
                  type="button"
                  onClick={() => navigate("/institucional/centro/nuevo")}
                >
                  <i className="fa-solid fa-plus me-2"></i>
                  Nuevo
                </button>
              </div>
            </div>
          </div>

          {/* Body */}
          <div>
            {loading ? (
              <div className="text-center text-secondary py-5">
                <div className="spinner-border" role="status" aria-hidden="true"></div>
                <div className="mt-3">Cargando centros…</div>
              </div>
            ) : centrosFormacion.length > 0 ? (
              <div className="overflow-hidden">
                <DataTable columns={columns} data={centrosFormacion} />
              </div>
            ) : (
              <div className="text-center text-secondary py-5">
                <div className="display-6 mb-2">🏫</div>
                <div className="fw-semibold">
                  No hay centros de formación registrados
                </div>
                <div className="small mb-3">
                  Registra un centro para iniciar la gestión.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListarCentros;